/**
 * Centralized runtime configuration for the web app.
 *
 * Values come from Vite env vars (see `.env.example`). The API key is a
 * non-secret identifier required by the backend `checking` middleware.
 */
export const config = {
  API_URL: import.meta.env.VITE_API_URL || "http://localhost:3000",
  API_KEY: import.meta.env.VITE_API_KEY || "uninfo_we2Tech_apikey",

  // Set at runtime via auth flows / Redux; defaults are empty.
  APP_KEY: "",
  ACCESS_TOKEN: "",
};